import { render, staticRenderFns } from "./ReportInfoTable.vue?vue&type=template&id=1e18283a&scoped=true&"
import script from "./ReportInfoTable.vue?vue&type=script&lang=ts&"
export * from "./ReportInfoTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e18283a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
